import React, { useState } from "react";
import { Pagination } from "@mantine/core";

interface PaginationType {
  onSelectPage: (page: number) => void;
  onSelectLimit: (limit: number) => void;
  totalPage: number;
  currentPage: number;
  itemStart: number;
  limit: number;
  totalItems: number;
}
function PagePaginate({
  onSelectPage,
  totalPage,
  currentPage,
  totalItems,
  onSelectLimit,
}: PaginationType) {
  const [selectedValue, setSelectedValue] = useState("");
  const options = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 40, label: "40" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const handleSelectChange = (event: any) => {
    setSelectedValue(event.target.value);
    onSelectLimit(Number(event.target.value));
  };

  return (
    <div className="w-full flex justify-between">
      <div className="flex gap-2 items-center">
        <p className="text-sm text-text-primary font-normal">จำนวนการแสดง</p>
        <select
          value={selectedValue}
          onChange={handleSelectChange}
          className="focus-visible:!outline-none border-[1px] rounded-lg border-gray-2 w-14 text-sm text-text-primary font-normal px-1"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <p className="text-sm text-text-primary font-normal">ลำดับ</p>
        {/* <p className="text-sm text-text-primary font-normal">{totalItems}</p> */}
      </div>

      <Pagination
        value={currentPage}
        total={totalPage}
        onChange={onSelectPage}
        size="xs"
        className="paginate-info w-fit"
      />
    </div>
  );
}

export default PagePaginate;
